<template>
    <div>
        <template v-if="getUserData().role === 'saysimple'">
            <h3>{{ $t("settings.channels.Authentication") }}</h3>

            <b-form-group
                v-for="column in Object.keys(authenticationColumns[channelData.provider.toLowerCase()])"
                :id="`fieldset-auth-${column}`"
                :key="`auth-${column}`"
                :description="$t(`settings.channels.${channelData.provider.toLowerCase()}.${column}.description`)"
                :label="$t(`settings.channels.${channelData.provider.toLowerCase()}.${column}.name`)"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="identity"
            >
                <b-form-input
                    :id="`input-auth-${column}`"
                    v-model="authenticationColumns[channelData.provider.toLowerCase()][column]"
                    type="text"
                />
            </b-form-group>
        </template>
        <hr />
    </div>
</template>

<script>
import { watchEffect } from "@vue/composition-api";
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import * as lodash from "lodash";
import { getUserData } from "@/auth/getUserData";

export default {
    components: {
        BCard,
        BFormGroup,
        BFormInput,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
        authenticationColumns: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        // Check if this channel already had a value for it's auth object and if so parse it and save the values so they can be displayed
        if (props.channelData.auth) {
            const auth = JSON.parse(props.channelData.auth);
            props.authenticationColumns[props.channelData.provider.toLowerCase()] = {
                ...props.authenticationColumns[props.channelData.provider.toLowerCase()],
                ...lodash.pick(
                    auth,
                    Object.keys(props.authenticationColumns[props.channelData.provider.toLowerCase()])
                ),
            };
        }

        // Whenever an auth property is changed rebuild the authString which we will send back to the database when saving.
        watchEffect(() => {
            if (props.authenticationColumns) {
                props.channelData.auth = JSON.stringify(
                    props.authenticationColumns[props.channelData.provider.toLowerCase()]
                );
            }
        });

        return {
            getUserData,
        };
    },
};
</script>
